import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { CreditCardIcon } from '@repo/ui/icons'
import Typography from '@repo/ui/typography'
import { useFormContext } from 'react-hook-form'

import useTranslate from '../../../lib/hooks/use-translate'
import { StaffInput } from '../../../lib/types/models/staff/staff-input'
import TextBreakWrapper from '../../elements/break-wrapper'
import ControlledSwitch from '../../elements/controlled-switch'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'
import IconBox from '../../elements/icon-box'
import InformationToolTip from '../../elements/information-tooltip'
import ControlledInput from '../../elements/inputs/controlled-input'

const StaffPersonalSpaceBankInformationForm = () => {
  const form = useFormContext<StaffInput>()
  const { t } = useTranslate()

  return (
    <IconBox
      className="py-6 px-5"
      title={
        <div className="flex items-center gap-4">
          <Typography variant="h6" color={tailwindColors.black.DEFAULT}>
            {t('staff.personal.space.your.bank.details')}
          </Typography>
          <InformationToolTip>
            <TextBreakWrapper
              translationKey="staff.personal.space.bank.info"
              variant="label-semibold"
              color={tailwindColors.white.DEFAULT}
            />
          </InformationToolTip>
        </div>
      }
      icon={CreditCardIcon}
    >
      <span id="staff-personal-space-bank-information" className="block h-0" />
      <div className="h-3" />
      <div className="grid grid-cols-2 gap-3 mobile:grid-cols-1">
        <FormField
          control={form.control}
          name="iban"
          render={({ field }) => (
            <FormItem className="w-full">
              <FormControl>
                <ControlledInput {...field} label="IBAN" type="text" />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="bic"
          render={({ field }) => (
            <FormItem className="w-full">
              <FormControl>
                <ControlledInput {...field} label="BIC" type="text" />
              </FormControl>
            </FormItem>
          )}
        />
        <div
          className={cn('border border-grey-stroke rounded w-full p-1', {
            'border-primary': form.watch('hasComplemenaryInsurance')
          })}
        >
          <FormField
            control={form.control}
            name="hasComplemenaryInsurance"
            render={({ field }) => (
              <FormItem className="w-full">
                <FormControl>
                  <ControlledSwitch
                    {...field}
                    label={t('staff.personal.space.has.complementary.insurance')}
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>
        <FormField
          control={form.control}
          name="complementaryInsuranceName"
          render={({ field }) => (
            <FormItem className="w-full">
              <FormControl>
                <ControlledInput
                  {...field}
                  label={t('staff.personal.space.complementary.insurance.name')}
                  type="text"
                />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    </IconBox>
  )
}

export default StaffPersonalSpaceBankInformationForm
